import settingsReducer from "./reducers"

export default settingsReducer